/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-plusplus */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-alert */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-cycle */
import React, { useRef, useState, useEffect } from 'react';
import { DialogUtility } from '@syncfusion/ej2-popups';
import {
  GridComponent,
  Inject,
  ColumnsDirective,
  ColumnDirective,
  Search,
  Sort,
  Filter,
  Resize,
  Edit,
  Toolbar,
  LazyLoadGroup,
  Group,
  Page,
  PdfExport,
  ExcelExport,
  ForeignKey,
} from '@syncfusion/ej2-react-grids';
import { ToolbarComponent, ItemsDirective, ItemDirective, AccordionComponent } from '@syncfusion/ej2-react-navigations';
import { TextBoxComponent, UploaderComponent } from '@syncfusion/ej2-react-inputs';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { Query } from '@syncfusion/ej2-data';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { Link, useNavigate } from 'react-router-dom';
import { useStateContext } from '../contexts/ContextProvider';
import { Header, Events, DevLog } from '../components';
import armband from '../data/watchsketch.png';

import { inv2Grid } from '../data/dummy';
import scribeHow from '../data/scribehow.png';

import './inventory.css';
import './Zackat.css';

const InventoryPage = () => {
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  const [currentDevice, setCurrentDevice] = useState(localStorage.getItem('currentDevice'));
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=inventory2');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);

  const { REACT_APP_API_ENDPOINT } = process.env;
  const valuerules = { required: true };
  const [enableEvents, setEvents] = useState(true);
  const add = { text: 'Add', tooltipText: 'Add Associate', prefixIcon: 'e-add', id: 'add', disabled: false };
  const person = { text: 'Associate', tooltipText: 'Associate', prefixIcon: 'e-user', id: 'associate', disabled: false };
  const toolbarOptions = [person, 'PdfExport', 'ExcelExport'];

  const [groups, setGroups] = useState([]);
  const [sortOptions, setSortColumns] = useState({});
  const [reload, setReload] = useState(false);
  const [inventoryid, setInventoryId] = useState('');
  const [selCharger, setCharger] = useState('');
  const [selVersion, setVersion] = useState('');
  const [selRRSP, setRRSP] = useState('');
  const [selUploadOrganization, setUploadOrganization] = useState('');
  const [selDevice, setDevice] = useState('');
  const [selAssociate, setAssociate] = useState('');
  const [selInventoryStatus, setInventoryStatus] = useState('');
  const [selIMEI, setIMEI] = useState('');
  const [selMSN, setMSN] = useState('');
  const [selStatus, setStatus] = useState('');
  const [selBattery, setBattery] = useState('');
  const [dataChanged, setDataChanged] = useState(false);
  const [inventory, setInventory] = useState(null);
  const [selOrganization, setOrganization] = useState('');
  const orgData = [];
  const associateData = [];
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  let grid;
  const [crudUpdate, setCrudUpdate] = useState(false);
  const [crudCreate, setCrudCreate] = useState(false);
  const [crudDelete, setCrudDelete] = useState(false);
  useEffect(() => {
    if (data.role && data.role.inventory && data.role.inventory.permissions.includes('Create')) {
      setCrudCreate(true);
    }
    if (data.role && data.role.inventory && data.role.inventory.permissions.includes('Update')) {
      setCrudUpdate(true);
    }
    if (data.role && data.role.inventory && data.role.inventory.permissions.includes('Delete')) {
      setCrudDelete(true);
    }
  }, [data]);
  const { boss, zRenderMode, isMobile } = useStateContext();

  const onToolbarChange = (args) => {
    if (grid) {
      const selectedRow = grid.getSelectedRecords()[0];
      if (args.target.textContent === 'Update') {
        grid.endEdit();
      }
      if (args.target.textContent === 'Edit') {
        grid.startEdit();
      }
      if (args.target.textContent === 'Delete') {
        grid.deleteRecord(selectedRow);
      }
      if (args.target.textContent === 'Add') {
        grid.addRecord();
      }
      if (args.target.textContent === 'Raw Events') {
        navigate(`../events?device=${selectedRow.device}`);
      }
      if (args.target.textContent === 'PDF Export') {
        const properties = {
          fileName: `PDFExport_Inventory_${new Date().toISOString()}.pdf`,
          pageOrientation: 'Landscape',
        };
        grid.pdfExport(properties);
      }
      if (args.target.textContent === 'Excel Export') {
        const properties = {
          fileName: `ExcelExport_Inventory_${new Date().toISOString()}.xlsx`,
        };
        grid.excelExport(properties);
      }
    }
  };

  const audioData = [
    { text: 'Not specified', value: 'na' },
  ];
  const [selectedAudioOption, setSelectedAudioOption] = useState(audioData[0]);
  function recordingDevice(e) {
    if (!grid) {
      return;
    }
    if (e.target.itemData.value === 'na') {
      return;
    }
    setSelectedAudioOption(e.target.itemData.value);
    const selectedRecords = grid.getSelectedRecords();
    if (!selectedRecords || selectedRecords.length === 0) {
      return;
    }
    const b = selectedRecords[0];
    if (!confirm(`Send recording ${e.target.itemData.text} to ${b.name}?`)) {
      return;
    }
    const message = `"audio": "${e.target.itemData.value}"`;
    const payload = { inventory: b, message };
    fetch(`${REACT_APP_API_ENDPOINT}/jasper`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // The added/edited data will be saved in the Grid
        DialogUtility.alert('audio request sent');
        setSelectedAudioOption('na');
      })
      .catch((error) => {
        console.error(error);
      });
  }
  const [selectedOption, setSelectedOption] = useState('');

  function smsDevice(e) {
    if (!grid) {
      return;
    }
    if (!e) {
      DialogUtility.alert('No device selected!');
      return;
    }
    const selectedRecords = grid.getSelectedRecords();
    if (!selectedRecords || selectedRecords.length === 0) {
      DialogUtility.alert('Please select a Device!');
      return;
    }
    const b = selectedRecords[0];
    const cmd = e.target.itemData.value;
    setSelectedOption(cmd);
    let message = '';
    if (cmd === 'na') {
      DialogUtility.alert('No command supplied');
      return;
    }
    if (b.device === '') {
      DialogUtility.alert('No device selected!');
      return;
    }

    b.name = inventory.device;
    if (inventory.associate && inventory.associate.length > 0) {
      b.name = `(${inventory.associate})`;
    }
    if (b.name === '(Place Holder)') {
      b.name = `(${inventory.associate}, ${inventory.device})`;
    }
    if (cmd === 'reset') {
      message = prompt(`Restart device ${b.device} ${b.name} or put device to sleep?`, 'restart');
      if (!message || message.length === 0) {
        return;
      }
      if (message.toLocaleLowerCase() === 'restart') {
        message = '"reset":"restart"';
      } else if (message.toLocaleLowerCase() === 'sleep') {
        message = '"reset":"sleep"';
      } else {
        return;
      }
    } else if (cmd === 'fota') {
      if (!confirm(`Send a FOTA request to ${b.name}`)) {
        return;
      }
      message = '"fota":"ind"';
    } else if (cmd === 'locate') {
      message = '"locate":"query"';
      if (!confirm(`Send a LOCATE request to ${b.name}`)) {
        return;
      }
    } else if (cmd === 'rehome') {
      message = prompt(`ReHome device ${b.device} ${b.name} production, staging or development?`, 'production');
      if (!message || message.length === 0) {
        return;
      }
      switch (message.toLocaleLowerCase()) {
        case 'production':
          message = '"srvr":{"url":"bio.zackatlabs.com", "port": "10900"}';
          break;
        case 'staging':
          message = '"srvr":{"url":"biometric.zackatlabs.com", "port": "10900"}';
          break;
        case 'development':
          message = '"srvr":{"url":"biometric.zackat.com", "port": "10900"}';
          break;
        default:
          message = `"srvr":{"url":"${message}", "port": "10900"}`;
          break;
      }
    } else {
      message = prompt(`What SMS would you like to send to ${b.device} ${b.name}?`, '');
    }
    if (!message || message.length === 0) {
      return;
    }
    const payload = { inventory: b, message };
    fetch(`${REACT_APP_API_ENDPOINT}/jasper`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        DialogUtility.alert(`${cmd} request sent`);
        setSelectedOption('na');
        // The added/edited data will be saved in the Grid
      })
      .catch((error) => {
        console.error(error);
      });
  }
  const [actionData, setActionData] = useState([]);
  useEffect(() => {
    const myActionData = [
      { text: 'Not specified', value: 'na' },
      { text: 'FOTA', value: 'fota' },
      { text: 'Locate', value: 'locate' },
      { text: 'Reset', value: 'reset' },
      { text: 'SMS', value: 'sms' },
      { text: 'Rehome', value: 'rehome' },
    ];
    setActionData(myActionData);
    setSelectedOption('na');
  }, []);

  const actionComponent = () => (
    <div>
      <DropDownListComponent id="invAction" dataSource={actionData} placeholder="Device Action" value={selectedOption} onChange={smsDevice} />
    </div>
  );
  const audioComponent = () => (
    <DropDownListComponent dataSource={audioData} placeholder="Send Recording" value={selectedAudioOption} onChange={recordingDevice} />
  );

  useEffect(() => {
    if (grid) {
      const selectedRecords = grid.getSelectedRecords();
      if (selectedRecords && selectedRecords.length === 1) {
        setInventoryId(selectedRecords[0]._id);
        setEvents(false);
      } else {
        setInventoryId('');
        setEvents(true);
      }
    } else {
      setInventoryId('');
      setEvents(true);
    }
  }, [dataChanged]);
  const cancelProfile = () => {
    setInventoryId('');
  };

  const saveProfile = (e) => {
    e.preventDefault();
    if (inventory.organizationid !== selOrganization) {
      const result = orgData.find(({ id }) => id === selOrganization);
      if (!confirm(`Would you like to move this Inventory ${inventory.device} from ${inventory.organizationid} to ${result.value}`)) {
        return;
      }
      inventory.organizationid = selOrganization;
      inventory.organization = result.value;
    }
    if (selDevice.length > 0 && (selDevice.length < 19 || selDevice.length > 20)) {
      DialogUtility.alert('Please provide a valid device for the inventory');
      return;
    }
    inventory.msn = selMSN;
    inventory.device = selDevice;
    inventory.imei = selIMEI;
    const inv = [];
    inv.push(inventory);
    fetch(`${REACT_APP_API_ENDPOINT}/inventory`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(inv),
    })
      .then((response) => response.json())
      .then(() => {
        // The added/edited data will be saved in the Grid
        // The default edit operation is cancelled
        DialogUtility.alert('Profile saved');
        cancelProfile();
        if (grid) {
          grid.clearSelection();
        }
      })

      .catch((error) => {
        DialogUtility.alert('An error has occured during Update!');
      });
  };

  const addProfile = () => {
    const result = orgData.find(({ id }) => id === selOrganization);
    const newinventory = {};
    newinventory.organizationid = selOrganization;
    if (!result || !result.value || result.value.length === 0) {
      DialogUtility.alert('Please select an Organization!');
      return;
    }
    newinventory.organization = result.value;
    if (selIMEI.length > 0 && selIMEI.length >= 15 && selIMEI.length <= 16) {
      newinventory.name = selIMEI;
    } else {
      DialogUtility.alert(`Invalid IMEI specified ${selIMEI}`);
      return;
    }
    if (selDevice.length >= 19 && selDevice.length <= 20) {
      newinventory.device = selDevice;
    } else {
      DialogUtility.alert(`Invalid Device specified ${selDevice}`);
      return;
    }
    newinventory.msn = selMSN;
    newinventory.imei = selIMEI;
    newinventory.simstatus = {};
    newinventory.status = 'stock';
    newinventory.associate = '';
    newinventory.associateid = '';
    const inv = [];
    inv.push(newinventory);
    if (!confirm(`Add Inventory ${selDevice} to ${result.value}`)) {
      return;
    }
    fetch(`${REACT_APP_API_ENDPOINT}/inventory`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(inv),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // The added/edited data will be saved in the Grid
        if (responseJson && responseJson._id) {
          newinventory._id = responseJson._id;
          setInventoryId(newinventory._id);
          setReload(!reload);
        }
        if (responseJson && responseJson.response && responseJson.response !== 'OK') {
          DialogUtility.alert(responseJson.response);
        }
      })
      .catch((error) => {
        DialogUtility.alert('An error has occured during New Inventory Insert!');
      });
  };

  function rowClicked() {
    setInventoryId('');
    setDataChanged(!dataChanged);
  }
  const groupOptions = {
    enableLazyLoading: false,
    columns: groups,
  };
  useEffect(() => {
    if (currentDevice && currentDevice.length > 0) {
      setDevice(currentDevice);
    }
  }, [currentDevice]);

  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    usr.limit = 1;
    let dev = selDevice;
    if (selDevice === '') {
      dev = selDevice && selDevice.length > 0 ? selDevice : '***___***';
    }
    // fetch data
    const dataFetch = async () => {
      setEvents(true);
      if (currentDevice && currentDevice.length > 0) {
        dev = currentDevice;
      }
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/inventory?${query}&abbrev=true&device=${dev}`;
      setLoading(true);
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json();
      if (mydata.user && mydata.user.preferences && mydata.user.preferences.inventory2) {
        if (mydata.user.preferences.inventory2.group) {
          setGroups(mydata.user.preferences.inventory2.group);
        } else {
          setGroups(['organizationid']);
        }
        if (mydata.user.preferences.inventory2.sort && mydata.user.preferences.inventory2.sort[0].direction) {
          const mysortedColumns = { columns: mydata.user.preferences.inventory2.sort };
          setSortColumns(mysortedColumns);
        }
      } else {
        if (currentDevice && currentDevice.length > 0) {
          DialogUtility.alert(`Device was not found ${currentDevice}!`);
        }

        setGroups(['organizationid']);
      }
      // set state when the data received
      setData(mydata);
      setLoading(false);
    };
    dataFetch();
  }, [reload]);
  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    // fetch data
    const inventoryFetch = async () => {
      if (inventoryid !== '' && inventoryid !== 'add_inventory') {
        const query = Object.entries(usr)
          .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
          .join('&');
        const url = `${REACT_APP_API_ENDPOINT}/inventory?${query}&inventoryid=${inventoryid}`;
        if (!usr.loggedIn) {
          navigate('/login');
          return;
        }
        const mydata = await (
          await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWTToken ${usr.token}`,
            },
          })
        ).json();
        if (mydata && mydata._id) {
          setStatus(`${mydata.status ? mydata.status : ''}`);
          setBattery(`${mydata.battery ? mydata.battery : ''}`);
          setDevice(`${mydata.device ? mydata.device : ''}`);
          setAssociate(`${mydata.associate ? mydata.associate : ''}`);
          setVersion(`${mydata.version ? mydata.version : ''}`);
          setCharger(`${mydata.charger ? mydata.charger : ''}`);
          setRRSP(`${mydata.rssi ? mydata.rssi : ''}`);
          setIMEI(`${mydata.imei ? mydata.imei : ''}`);
          setMSN(`${mydata.msn ? mydata.msn : ''}`);
          if (mydata.organization) {
            setOrganization(mydata.organizationid ? mydata.organizationid : null);
          }
          setInventoryStatus(`Status:${mydata.status.toUpperCase()}\r\nVersion:${mydata.version}\r\nBattery:${mydata.battery}\r\nCharger:${mydata.charger}\r\nRRSP:${mydata.rssi}\r\n`);
          setInventory(mydata);
        }
      }
    };
    inventoryFetch();
  }, [inventoryid]);

  if (loading) {
    return <p>Loading... </p>;
  }
  if (data.organization) {
    data.organization.forEach((element) => {
      orgData.push({ id: element._id, value: element.title });
    });
  }
  if (data.associates) {
    data.associates.forEach((element) => {
      associateData.push({ id: element._id, value: element.name });
    });
  }

  if (data.role && data.role.inventory && !data.role.inventory.permissions.includes('Read')) {
    return <p>Not authorized...</p>;
  }
  const editing = {
    allowEditing: crudUpdate,
    allowAdding: crudCreate,
    allowDeleting: crudDelete,
    showConfirmDialog: false,
    showDeleteConfirmDialog: true,
    allowEditOnDblClick: false,
    mode: 'Dialog',
  };
  function setUserPreferences(pref, val) {
    if (!data.user.preferences) {
      data.user.preferences = {};
    }
    if (!data.user.preferences.inventory2) {
      data.user.preferences.inventory2 = {};
    }
    if (pref === 'group') {
      data.user.preferences.inventory2 = { group: val, sort: data.user.preferences.inventory2.sort };
    } else if (pref === 'sort') {
      data.user.preferences.inventory2 = { group: data.user.preferences.inventory2.group, sort: val };
    }
    // Remove the New Password to avoid creating a new password
    data.user.newPassword = '';
    // Avoid Password comparison
    data.user.password = '';
    if (data.user.lastLogin && data.user.lastLogin === '') {
      data.user.lastLogin = '1970-01-01T00:00:00.000Z';
    }

    fetch(`${REACT_APP_API_ENDPOINT}/user`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(data.user),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson && responseJson.response && responseJson.response !== 'OK') {
          DialogUtility.alert(responseJson.response);
        }
      })
      .catch(() => {
      });
  }
  const actionBegin = (args) => {
    if (args.requestType === 'ungrouping' || args.requestType === 'grouping') {
      const index = groups.indexOf(args.columnName);
      if (index > -1 && args.requestType === 'ungrouping') { // only splice array when item is found
        groups.splice(index, 1); // 2nd parameter means remove one item only
      } else if (index === -1 && args.requestType === 'grouping') { // only splice array when item is found
        groups.push(args.columnName); // 2nd parameter means remove one item only
      }
      setUserPreferences('group', groups);
    } else if (args.requestType === 'sorting') {
      setUserPreferences('sort', [{ field: args.columnName, direction: args.direction }]);
    }
  };
  const associates = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: data.associates,
      fields: { value: '_id', text: 'name' },
      query: new Query(),
    },
  };
  const searchThis = (args) => {
    const search = document.getElementById('inventorysearch');
    if (search && search.value && search.value.length > 0) {
      localStorage.setItem('currentDevice', search.value);
      setCurrentDevice(search.value);
      setDevice(search.value);
      setReload(!reload);
    }
  };
  const handleKeyDown = (e) => {
    // Check if the pressed key is "Enter"
    if (e.key === 'Enter') {
      // Prevent the default form submission behavior
      e.preventDefault();
      // Perform your search or submission logic here
      searchThis(e);
      // Optional: Clear the textbox after searching
      // setValue('');
    }
  };
  const inputStyle = { width: '400px', display: 'inline-block', float: 'right' };

  const searchComponent = () => (
    <div className="pt-2 relative mx-auto text-gray-600">
      <input
        className="border-2 border-gray-300 bg-white h-10 px-5 pr-16 rounded-lg text-sm focus:outline-none searchtext"
        type="search"
        name="search"
        style={inputStyle}
        defaultValue={currentDevice}
        id="inventorysearch"
        placeholder="Search, device, imei, or case sensitive msn"
        onKeyDown={handleKeyDown}
      />
      <button type="button" className="absolute right-0 top-0 mt-5 mr-4" onClick={searchThis}>
        <svg
          className="text-gray-600 h-4 w-4 fill-current"
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          id="Capa_1"
          x="0px"
          y="0px"
          viewBox="0 0 56.966 56.966"
          xmlSpace="preserve"
          width="512px"
          height="512px"
        >
          <path
            d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z"
          />
        </svg>
      </button>
    </div>
  );

  const actionComplete = (args) => {
    const editedData = args.data;
    /** Set initial Focus */
    if (args.requestType === 'beginEdit') {
      // eslint-disable-next-line prefer-destructuring
      const dialog = args.dialog;
      dialog.width = '400px';
      dialog.header = `Details of ${args.rowData.device}`;
    }
    if (args.requestType === 'save' && args.form && args.action === 'add') {
      if (editedData && editedData.device.length >= 19 && editedData.device.length <= 20) {
        if (isNaN(args.data.device)) {
          DialogUtility.alert(`NaN Invalid Device ID ${editedData.device}`);
          args.cancel = true;
          setReload(!reload);
          return;
        }

        // Here you can send the updated data to your server using AJAX call

        editedData.simstatus = { status: 'active' };
        const oresult = orgData.find(({ id }) => id === editedData.organizationid);
        if (!oresult) {
          DialogUtility.alert('Error finding Organization');
          args.cancel = true;
          setReload(!reload);
          return;
        }
        editedData.organization = oresult.value;
        const result = associateData.find(({ id }) => id === editedData.inventoryid);
        if (result) {
          editedData.associate = result.value;
        }
        fetch(`${REACT_APP_API_ENDPOINT}/inventory`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(editedData),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The default edit operation is cancelled
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              DialogUtility.alert(responseJson.response);
              setReload(!reload);
              args.cancel = true;
            }
            // The added/edited data will be saved in the Grid
            if (responseJson && responseJson._id) {
              args.data._id = responseJson._id;
            }
          })
          .catch((error) => {
            setReload(!reload);
            args.cancel = true;
          });
      } else {
        DialogUtility.alert(`Invalid device ID ${args.data.device}`);
        setReload(!reload);
      }
    } else if (args.requestType === 'save' && args.form && args.action === 'edit') {
      if (args.data) {
        const invs = [];
        if (editedData.associateid) {
          const result = associateData.find(({ id }) => id === editedData.inventoryid);
          if (result) {
            editedData.associate = result.value;
          }
        }
        const oresult = orgData.find(({ id }) => id === editedData.organizationid);
        if (!oresult) {
          DialogUtility.alert('Error finding Organization');
          args.cancel = true;
          setReload(!reload);
          return;
        }
        editedData.organization = oresult.value;
        invs.push(editedData);
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/inventory`, {
          method: 'UPDATE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(invs),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The default edit operation is cancelled
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              DialogUtility.alert(responseJson.response);
              args.cancel = true;
            }
            // The added/edited data will be saved in the Grid
          })
          .catch(() => {
            args.cancel = true;
          });
      }
    } else if (args.requestType === 'batchsave') {
      if (args.rows && args.rows.length > 0) {
        const invs = [];
        for (let x = 0; x < args.rows.length; x++) {
          invs.push(args.rows[x].data);
        }
        // The default edit operation is cancelled

        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/inventory`, {
          method: 'UPDATE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(invs),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              DialogUtility.alert(responseJson.response);
              args.cancel = true;
              setReload(!reload);
            }
          })
          .catch(() => {
            args.cancel = true;
            setReload(!reload);
          });
      }
    } else if (args.requestType === 'delete') {
      let entry = ' this entry?';
      if (args.data.length > 1) {
        entry = ' these entries?';
      }
      if (args.data) {
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/inventory`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(editedData),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            // The default edit operation is cancelled
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              DialogUtility.alert(responseJson.response);
              args.cancel = true;
            }
            setInventoryId('');
            setReload(!reload);
          })
          .catch(() => {
            args.cancel = true;
            setReload(!reload);
          });
      }
    }
  };

  function onFileUpload(args) {
    // add addition data as key-value pair.
    const result = orgData.find(({ id }) => id === selUploadOrganization);
    if (!result || !result.value || result.value === '') {
      DialogUtility.alert('Invalid Organization');
      args.cancel = true;
      return;
    }
    if (!confirm(`Upload to ${result.value}`)) {
      args.cancel = true;
      return;
    }
    args.customFormData = [{ organizationid: selUploadOrganization }];
  }
  let uploadObj;
  const path = {
    removeUrl: `${REACT_APP_API_ENDPOINT}/inventoryremove`,
    saveUrl: `${REACT_APP_API_ENDPOINT}/inventoryupload`,
  };

  const FilterOptions = {
    type: 'Menu',
  };
  function completeUpload(args) {
    DialogUtility.alert('Import Upload Complete!');
  }
  const buttons = { browse: 'Choose File', clear: 'Clear All', upload: 'Upload All' };
  const currentThemeColor = localStorage.getItem('colorMode');
  const clickHandler = (args) => {
    if (grid && args.item.properties.text === 'PDF Export') {
      const properties = {
        fileName: `PDFExport_Inventory_${new Date().toISOString()}.pdf`,
        pageOrientation: 'Landscape',
      };
      grid.pdfExport(properties);
    } else if (grid && args.item.properties.text === 'Excel Export') {
      const properties = {
        fileName: `ExcelExport_Inventory_${new Date().toISOString()}.xlsx`,
      };
      grid.excelExport(properties);
    } else if (grid && args.item.properties.text === 'Batch') {
      if (grid.properties.editSettings.properties.mode === 'Dialog') {
        grid.properties.editSettings.properties.mode = 'Batch';
      } else {
        grid.properties.editSettings.properties.mode = 'Dialog';
      }
    } else if (grid && args.item.properties.text === 'Events') {
      const selectedRecords = grid.getSelectedRecords();
      if (!selectedRecords || selectedRecords.length === 0) {
        DialogUtility.alert('Please select a device');
      } else if (selectedRecords && selectedRecords.length === 1) {
        navigate(`../events?device=${selectedRecords[0].device}`);
      }
    } else if (grid && args.item.properties.text === 'Associate') {
      const selectedRecords = grid.getSelectedRecords();
      if (!selectedRecords || selectedRecords.length === 0 || !selectedRecords[0].associateid || selectedRecords[0].associateid === '') {
        DialogUtility.alert('Please select a device');
      } else if (selectedRecords && selectedRecords.length === 1 && selectedRecords[0].associateid && selectedRecords[0].resultField && selectedRecords[0].resultField[0] && selectedRecords[0].resultField[0].name) {
        localStorage.setItem('currentAssociate', selectedRecords[0].resultField[0].name);
        // navigate(`../associatepage?id=${selectedRecords[0].associateid}&name=${selectedRecords[0].resultField[0].name}`);
        navigate('../associatepage');
      }
    } else if (grid && args.item.properties.text === 'Add') {
      setDevice('');
      setIMEI('');
      setMSN('');
      setOrganization(null);
      setInventory(null);
      setInventoryId('add_inventory');
    }
  };
  const orgRule = { required: true };
  const organizations = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: data.organization,
      fields: { value: '_id', text: 'title' },
      query: new Query(),
    },
  };
  return (
    <div className="m-2 md:m-1 mt-2 p-1 md:p-1 bg-white rounded-3xl zackat-divalh">
      <img
        className="w-20"
        src={armband}
        alt="arm band"
      />
      <div className="flex">
        <Link
          className="my-link"
          to="https://scribehow.com/viewer/How_to_View_Item_Events_and_Dev_Logs__6-Oidid7RhS-ORA6JrAdhA"
          target="_blank"
        >
          <img src={scribeHow} width={20} height={20} />
        </Link>
        <Header category="Inventory" title="Device" />
      </div>
      <div style={{
        backgroundColor: currentThemeColor,
        textAlign: 'left',
        marginTop: '-40px',
      }}
      >
        <div id="droparea">
          {1 === 0 && (
          <div className="control-section accordion-control-section" style={{ width: '45%' }}>
            <div className="control Accordion-sample" style={{ margin: '25px 0' }}>
              <AccordionComponent>
                <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-8">
                  <div className="e-input-group">
                    <div className="mt-4"> Import </div>
                  </div>
                  <div className="mt-2 e-input-group">
                    <div>
                      <DropDownListComponent id="droporg" cssClass="e-outline" dataSource={organizations.params.dataSource} fields={organizations.params.fields} placeholder="Select Organization" value={selUploadOrganization} onChange={(v) => { setUploadOrganization(v.value); }} />
                    </div>
                    <UploaderComponent
                      id="fileupload"
                      type="file"
                      ref={(uplaod) => { uploadObj = uplaod; }}
                      asyncSettings={path}
                      buttons={buttons}
                      multiple={false}
                      actionComplete={completeUpload}
                      autoUpload={false}
                      uploading={onFileUpload}
                      allowedExtensions=".csv"
                    />
                  </div>
                </div>
              </AccordionComponent>
            </div>
          </div>
          )}
          {!loading && (
          <div>
            <ToolbarComponent id="toolbar" onClick={onToolbarChange}>
              <ItemsDirective>
                {boss && <ItemDirective text="Raw Events" prefixIcon="e-justify" disabled={inventoryid === ''} />}
                <ItemDirective type="Separator" />
                <ItemDirective template={actionComponent} disabled={inventoryid === ''} />
                <ItemDirective type="Separator" />
                <ItemDirective text="Search" template={searchComponent} style={{ float: 'right !important' }} />
                <ItemDirective type="Separator" />
              </ItemsDirective>
            </ToolbarComponent>
          </div>
          )}
        </div>
        <div style={{
          textAlign: 'left',
        }}
        >
          <div className="flex" height="300px">
            <GridComponent
              dataSource={data.inventory}
              enableHover
              allowPaging
              pageSettings={{ pageCount: 5 }}
              toolbar={toolbarOptions}
              editSettings={editing}
              allowSorting
              allowResizing
              allowFiltering={data && data.inventory && data.inventory.length > 0}
              filterSettings={FilterOptions}
              actionComplete={actionComplete}
              actionBegin={actionBegin}
              toolbarClick={clickHandler}
              allowTextWrap
              allowPdfExport
              allowExcelExport
              allowGrouping
              recordClick={rowClicked}
              groupSettings={groupOptions}
              sortSettings={sortOptions}
              enableAdaptiveUI={isMobile}
              rowRenderingMode={zRenderMode}
              ref={(g) => { grid = g; }}
            >
              <ColumnsDirective>
                <ColumnDirective
                  field="device"
                  headerText="Device"
                  width="80"
                  textAlign="Left"
                  validationRules={valuerules}
                  visible
                />
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                {inv2Grid.map((item, index) => <ColumnDirective key={index} {...item} />)}

                <ColumnDirective
                  field="organizationid"
                  headerText="Organization"
                  width="70"
                  textAlign="Left"
                  editType="dropdownedit"
                  edit={organizations}
                  validationRules={valuerules}
                  visible
                  foreignKeyField="_id"
                  foreignKeyValue="title"
                  dataSource={organizations.params.dataSource}
                />
              </ColumnsDirective>
              <Inject services={[Search, Page, Edit, Toolbar, Filter, Sort, Resize, PdfExport, ExcelExport, ForeignKey, LazyLoadGroup, Group]} />
            </GridComponent>
          </div>
        </div>
      </div>
      {inventoryid !== '' && crudUpdate && (
        <div className="control-section accordion-control-section" style={{ width: '100%' }}>
          <div className="control Accordion-sample" style={{ margin: '25px 0' }}>
            <AccordionComponent>
              <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-8">
                <div className="e-input-group">
                  <div className="mt-4"> Edit Inventory </div>
                </div>
                <form>
                  {inventoryid !== 'add_inventory' && (
                  <div className="control-section accordion-control-section">
                    <div className="control Accordion-sample" style={{ margin: '25px 0' }}>
                      <AccordionComponent>
                        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-8">
                          <div className="e-input-group">
                            <div className="mt-4"> Status </div>
                          </div>
                          <div className="mt-2 e-mygrid">
                            <TextBoxComponent className="mt-2" multiline placeholder="" value={selInventoryStatus} title="current status information " disabled readOnly floatLabelType="Auto" onChange={(e) => { }} />
                          </div>
                        </div>
                      </AccordionComponent>
                    </div>
                  </div>
                  )}
                  {inventoryid !== 'add_inventory'
            && (
            <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
              <div className="e-input-group">
                <TextBoxComponent placeholder="Associate" title="Controlled via Associate tab" value={selAssociate} disabled readOnly cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setAssociate(v.value); }} />
              </div>
            </div>
            )}
                  <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
                    <div className="e-input-group">
                      <TextBoxComponent placeholder="IMEI" title="Controlled via Manager tab" value={selIMEI} cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setIMEI(v.value); }} />
                      <TextBoxComponent placeholder="MSN" value={selMSN} showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setMSN(v.value); }} />
                    </div>
                  </div>

                  <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
                    <div className="e-input-group">
                      <TextBoxComponent placeholder="Device" value={selDevice} showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setDevice(v.value); }} />
                    </div>
                  </div>
                  <div className="row custom-margin">
                    <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6">
                      <div className="e-input-group">
                        <DropDownListComponent id="orgelement" cssClass="e-outline" dataSource={organizations.params.dataSource} fields={organizations.params.fields} placeholder="Select Organization" value={selOrganization} onChange={(v) => { setOrganization(v.value); }} />
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-12 col-sm-12 col-lg-6 col-md-6">
                    <ButtonComponent cssClass="e-outline e-warning" onClick={cancelProfile}>Cancel</ButtonComponent>
                    {crudUpdate && <ButtonComponent style={{ float: 'right' }} cssClass="e-outline e-info" onClick={saveProfile}>Save</ButtonComponent>}
                  </div>
                </form>
              </div>
            </AccordionComponent>
          </div>
        </div>
      )}
      {inventory && inventoryid !== '' && (
      <div className="control-section accordion-control-section" style={{ width: '100%' }}>
        <div className="control Accordion-sample" style={{ margin: '25px 0' }}>
          <AccordionComponent>
            <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-8">
              <div className="e-input-group">
                <div className="mt-4"> Events </div>
              </div>
              <div>
                <Events props={inventory} />
              </div>
            </div>
          </AccordionComponent>
        </div>
      </div>
      )}
      {boss && inventory && inventoryid !== '' && (
      <div className="control-section accordion-control-section" style={{ width: '100%' }}>
        <div className="control Accordion-sample" style={{ margin: '25px 0' }}>
          <AccordionComponent>
            <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-8">
              <div className="e-input-group">
                <div className="mt-4"> Dev Logs </div>
              </div>
              <div>
                <DevLog props={inventory} />
              </div>
            </div>
          </AccordionComponent>
        </div>
      </div>
      )}
    </div>
  );
};
export default InventoryPage;
